import { IS_INDIAN_EXCHANGE } from 'constants/constants';
import { isNan } from 'helpers/utils';
import subscribe from 'HOC/subscribe';
import { spotPriceState } from 'selectors/priceSelectors';

const sanitizePrice = (price: any) => {
  //  parseFloat(NaN) is NaN, Hence, checking the NaN first.
  if (isNan(price) || parseFloat(price) === 0) {
    return '-';
  }
  return IS_INDIAN_EXCHANGE ? `$${price}` : `${price}`;
};

const SelectedProductSpotPrice = () => {
  const spotPrice = spotPriceState();
  return <span className="value" data-palette="SelectedProductSpotPrice">{`${sanitizePrice(spotPrice)}`}</span>;
};

export default subscribe(SelectedProductSpotPrice);
